import ListItemPage from './ListItemPage';

export default ListItemPage;
